import { BarChart3, Vote, Crown } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface PartyPublicStatsProps {
  className?: string
}

export function PartyPublicStats({ className }: PartyPublicStatsProps) {
  return (
    <Card className={cn(className)}>
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <BarChart3 className="h-4 w-4" />
          Electoral Standing
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Stats grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1">
              <div className="flex items-center gap-1.5 text-muted-foreground">
                <Vote className="h-3.5 w-3.5" />
                <span className="text-xs">Seats</span>
              </div>
              <p className="text-lg font-semibold text-muted-foreground">—</p>
            </div>
            <div className="space-y-1">
              <div className="flex items-center gap-1.5 text-muted-foreground">
                <BarChart3 className="h-3.5 w-3.5" />
                <span className="text-xs">Vote Share</span>
              </div>
              <p className="text-lg font-semibold text-muted-foreground">—</p>
            </div>
          </div>

          <div className="space-y-1">
            <div className="flex items-center gap-1.5 text-muted-foreground">
              <Crown className="h-3.5 w-3.5" />
              <span className="text-xs">Government Role</span>
            </div>
            <p className="text-sm text-muted-foreground">—</p>
          </div>

          {/* Placeholder message */}
          <div className="text-center pt-2 border-t">
            <p className="text-xs text-muted-foreground">
              No elections have occurred yet
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
